/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITIALSTATE = {
    result: {
        permit_types: {},
        need_to_know: [],
    },
};

export default function permitReducer(state = INITIALSTATE, action) {
    let st = { ...state };

    switch (action.type) {
        case types.GET_PERMIT:
            st = cloneState(state);
            st.result = action.payload;
            delete st.fetch_err;
            return st;

        case types.GET_PERMIT_ERROR:
            st = cloneState(state);
            st.fetch_err = action.error;
            return st;

        case types.GET_RECAREA:
            st = cloneState(state);
            st.recarea = action.payload;
            delete st.recarea_err;
            return st;

        case types.GET_RECAREA_ERROR:
            st = cloneState(state);
            st.recarea_err = action.error;
            return st;

        case types.GET_PERMIT_RESERVATION_ALERT:
            st.reservation_alert = action.payload;
            delete st.reservation_alert_err;
            return st;

        case types.GET_PERMIT_RESERVATION_ALERT_ERROR:
            st.reservation_alert_err = action.error;
            delete st.reservation_alert;
            return st;

        case types.SET_PERMIT_TYPE:
            st = cloneState(state);
            st.permitType = action.permitType;
            return st;

        case types.SET_PERMIT_DATE:
            st = cloneState(state);
            st.permitDate = action.permitDate;
            return st;

        case types.VERIFY_ALTERNATE:
            st = cloneState(state);
            st.verify_alternate_success = action.payload;
            delete st.verify_alternate_error;
            return st;

        case types.VERIFY_ALTERNATE_ERROR:
            st = cloneState(state);
            st.verify_alternate_error = action.error;
            delete st.verify_alternate_success;
            return st;

        case types.CONFIRM_ALTERNATE:
            st = cloneState(state);
            st.confirm_alternate_success = action.payload;
            delete st.confirm_alternate_error;
            return st;

        case types.CONFIRM_ALTERNATE_ERROR:
            st = cloneState(state);
            st.confirm_alternate_error = action.error;
            delete st.confirm_alternate_success;
            return st;
        default:
            return st;
    }
}
